import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Treatments from "@/pages/Treatments";
import AestheticTreatments from "@/pages/AestheticTreatments";
import TreatmentDetail from "@/pages/TreatmentDetail";
import Problems from "@/pages/Problems";
import ProblemDetail from "@/pages/ProblemDetail";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import { TREATMENTS, AESTHETIC_TREATMENTS, LOCATIONS } from "@/data/site";

// Legacy URLs kept redirecting (301-style) to the new SEO-friendly URLs
const OLD_TREATMENT_SLUGS = {
  "dental-implants": "dental-implants-varanasi",
  "root-canal-treatment": "root-canal-treatment-varanasi",
  "teeth-cleaning": "teeth-cleaning-varanasi",
  "tooth-extraction": "tooth-extraction-varanasi",
  "wisdom-tooth-removal": "wisdom-tooth-removal-varanasi",
  "smile-makeover": "smile-makeover-varanasi",
  "braces-and-aligners": "braces-and-aligners-varanasi",
  "childrens-dentistry": "childrens-dentistry-varanasi",
  "emergency-dental-care": "emergency-dental-care-varanasi",
};
const OLD_LOCATION_SLUGS = {
  "dentist-in-paharia": "dentist-in-paharia",
  "dentist-in-pandeypur": "dentist-in-pandeypur",
  "dentist-near-ashapur": "dentist-in-ashapur",
  "dentist-near-sarnath": "dentist-in-sarnath",
  "dentist-near-orderly-bazar": "dentist-in-orderly-bazar",
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/dr-ankesh-seth" element={<About />} />
              <Route path="/about" element={<Navigate to="/dr-ankesh-seth" replace />} />

              <Route path="/treatments" element={<Treatments />} />
              {TREATMENTS.map((t) => (
                <Route key={t.slug} path={`/${t.slug}`} element={<TreatmentDetail />} />
              ))}
              {Object.entries(OLD_TREATMENT_SLUGS).map(([oldSlug, newSlug]) => (
                <Route
                  key={oldSlug}
                  path={`/treatments/${oldSlug}`}
                  element={<Navigate to={`/${newSlug}`} replace />}
                />
              ))}

              <Route path="/aesthetic-treatments" element={<AestheticTreatments />} />
              {AESTHETIC_TREATMENTS.map((t) => (
                <Route key={t.slug} path={`/${t.slug}`} element={<TreatmentDetail />} />
              ))}

              <Route path="/problems" element={<Problems />} />
              <Route path="/problems/:slug" element={<ProblemDetail />} />

              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />

              <Route path="/locations" element={<Locations />} />
              {LOCATIONS.map((l) => (
                <Route key={l.slug} path={`/${l.slug}`} element={<LocationDetail />} />
              ))}
              {Object.entries(OLD_LOCATION_SLUGS).map(([oldSlug, newSlug]) => (
                <Route
                  key={oldSlug}
                  path={`/locations/${oldSlug}`}
                  element={<Navigate to={`/${newSlug}`} replace />}
                />
              ))}

              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
